// Links das lojas do app Joyn — fonte única pra qualquer convite de
// download no site. Mesmo app/pacote de public/baixar/index.html, mas sem
// os parâmetros de campanha do Facebook Ads de lá (ct=fb_ads /
// utm_source=facebook): reaproveitá-los atribuiria visitas orgânicas à
// campanha paga.

export const APP_STORE_ID = '6779234600';
export const APP_STORE_URL = `https://apps.apple.com/br/app/joyn-eventos/id${APP_STORE_ID}`;
// referrer identifica instalações vindas da página do evento no site.
// App Store fica sem ct= por enquanto: o /baixar usa pt= vazio, e sem
// provider token a Apple não atribui a campanha.
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.joynapp.app&referrer=utm_source%3Djoyn_site%26utm_medium%3Devento%26utm_campaign%3Devento_compartilhado';

// 'ios' | 'android' | 'desktop'. iPadOS 13+ se identifica como Mac no
// userAgent — o toque (maxTouchPoints) é o que diferencia de um Mac de verdade.
export function detectPlatform() {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  return 'desktop';
}

// Loja certa pro aparelho; null no desktop (lá mostramos as duas).
export function getStoreUrlForPlatform(platform) {
  if (platform === 'ios') return APP_STORE_URL;
  if (platform === 'android') return GOOGLE_PLAY_URL;
  return null;
}
